export const SODIUM_WARNING_DISCLAIMER = 'Sodium content higher than daily recommended limit (2,300 mg). High sodium intake can increase blood pressure and risk of heart disease and stroke.';
